module.exports = __webpack_public_path__ + "static/media/AssistinAccident.73b0c6c0.svg";